import React, { memo, useEffect, useCallback, useMemo, useState } from 'react';
import SidebarFilters from 'V2/components/SidebarFilters';
import GenericFilter from 'V2/components/Generics/GenericFilter';

import Container, { ActionContainer, ClearFilterButton } from './styles';

const OperationFilter = ({ type, menu, onFilter, onClear, options }) => {
  const [filters, setFilters] = useState([
    {
      type: 'default',
      title: 'Categorias de ativos',
      name: 'assetsCategory',
      placeholder: ' ',
      options: [],
    },
    {
      type: 'default',
      title: 'Ativos',
      name: 'assetTicker',
      placeholder: ' ',
      options: [],
    },
    {
      type: 'default',
      title: 'Categorias de estruturas',
      name: 'structureCategory',
      placeholder: ' ',
      options: [],
    },
    {
      type: 'default',
      title: 'Estruturas',
      name: 'structures',
      placeholder: ' ',
      options: [],
    },
    {
      type: 'default',
      title: 'Encerramentos',
      name: 'closingDate',
      placeholder: ' ',
      options: [],
    },
    {
      type: 'default',
      title: 'Compra da ação',
      name: 'paperIncluded',
      placeholder: ' ',
      options: [],
    },
  ]);

  const getOptionSelected = useCallback(option => option?.map(({ id, isSelected }) => (isSelected ? id : undefined))?.filter(data => !!data) || [], []);

  const createOptions = useCallback(optionData => optionData?.map(option => ({
    id: `${option}`,
    value: option,
    label: `${option}`,
    isSelected: false,
  })), []);

  const createOptionsWithID = useCallback(optionData => optionData?.map(option => ({
    id: `${option.id}`,
    value: option.id,
    label: `${option.nome}`,
    isSelected: false,
  })), []);

  const createFilter = useCallback(() => {
    const ASSETSCATEGORY = filters[0];
    const ASSETTICKER = filters[1];
    const STRUCTURESCATEGORY = filters[2];
    const STRUCTURES = filters[3];
    const CLOSINGDATE = filters[4];
    const PAPERINCLUDED = filters[5];

    const HAS_ASSETTICKER_OPTIONS = ASSETTICKER.options.length === 0;
    const HAS_ASSETSCATEGORY_OPTIONS = ASSETSCATEGORY.options.length === 0;
    const HAS_STRUCTURES_CATEGORY_OPTIONS = STRUCTURESCATEGORY.options.length === 0;
    const HAS_STRUCTURES_OPTIONS = STRUCTURES.options.length === 0;
    const HAS_CLOSINGDATE_OPTIONS = CLOSINGDATE.options.length === 0;
    const HAS_PAPERINCLUDED_OPTIONS = PAPERINCLUDED.options.length === 0;

    if (HAS_ASSETTICKER_OPTIONS
      || HAS_ASSETSCATEGORY_OPTIONS
      || HAS_STRUCTURES_CATEGORY_OPTIONS
      || HAS_STRUCTURES_OPTIONS
      || HAS_CLOSINGDATE_OPTIONS
      || HAS_PAPERINCLUDED_OPTIONS
    ) {
      setFilters([
        { ...ASSETSCATEGORY, options: createOptions(options?.CategoriasAtivo) },
        { ...ASSETTICKER, options: createOptions(options?.Ativos) },
        { ...STRUCTURESCATEGORY, options: createOptions(options?.TiposEstrategia) },
        { ...STRUCTURES, options: createOptionsWithID(options?.Estruturas) },
        { ...CLOSINGDATE, options: createOptions(options?.Vencimentos) },
        { ...PAPERINCLUDED, options: options?.PapelIncluso },
      ]);
    }
  }, [filters, options]);

  const handleOnFilter = useCallback((filterData) => {
    onFilter({
      CategoriasAtivo: getOptionSelected(filterData[0].options),
      Ativos: getOptionSelected(filterData[1].options),
      TiposEstrategia: getOptionSelected(filterData[2].options),
      Estruturas: getOptionSelected(filterData[3].options),
      Vencimentos: getOptionSelected(filterData[4].options),
      PapelIncluso: getOptionSelected(filterData[5].options),
    });
  }, []);

  const handleOnClear = useCallback(() => {
    const ASSETSCATEGORY = filters[0];
    const ASSETTICKER = filters[1];
    const STRUCTURESCATEGORY = filters[2];
    const STRUCTURES = filters[3];
    const CLOSINGDATE = filters[4];
    const PAPERINCLUDED = filters[5];

    setFilters([
      { ...ASSETSCATEGORY, options: createOptions(options?.CategoriasAtivo) },
      { ...ASSETTICKER, options: createOptions(options?.Ativos) },
      { ...STRUCTURESCATEGORY, options: createOptions(options?.TiposEstrategia) },
      { ...STRUCTURES, options: createOptionsWithID(options?.Estruturas) },
      { ...CLOSINGDATE, options: createOptions(options?.Vencimentos) },
      { ...PAPERINCLUDED, options: options?.PapelIncluso },
    ]);

    onClear({
      CategoriasAtivo: [],
      Ativos: [],
      TiposEstrategia: [],
      Estruturas: [],
      Vencimentos: [],
      PapelIncluso: [],
    });
  }, [options]);

  const resetFilters = useCallback(() => {
    const ASSETSCATEGORY = filters[0];
    const ASSETTICKER = filters[1];
    const STRUCTURESCATEGORY = filters[2];
    const STRUCTURES = filters[3];
    const CLOSINGDATE = filters[4];
    const PAPERINCLUDED = filters[5];

    setFilters([
      { ...ASSETSCATEGORY, options: createOptions(options?.CategoriasAtivo) },
      { ...ASSETTICKER, options: createOptions(options?.Ativos) },
      { ...STRUCTURESCATEGORY, options: createOptions(options?.TiposEstrategia) },
      { ...STRUCTURES, options: createOptionsWithID(options?.Estruturas) },
      { ...CLOSINGDATE, options: createOptions(options?.Vencimentos) },
      { ...PAPERINCLUDED, options: options?.PapelIncluso },
    ]);
  }, [options]);

  useEffect(() => {
    createFilter();
  }, [options]);

  useEffect(() => {
    resetFilters();
    onClear({
      CategoriasAtivo: [],
      Ativos: [],
      TiposEstrategia: [],
      Estruturas: [],
      Vencimentos: [],
      PapelIncluso: [],
    });
  }, [type, menu]);

  return (
    <GenericFilter
      onFilter={handleOnFilter}
      onClear={handleOnClear}
      filters={filters}
      filterNames={[
        { name: 'assetTicker', size: 175 },
        { name: 'assetsCategory', size: 75 },
        { name: 'structureCategory', size: 100 },
        { name: 'structures', size: 150 },
        { name: 'closingDate', size: 150 },
        { name: 'paperIncluded', size: 50 },
      ]}
    />
  );
};

export default memo(OperationFilter);
